import { apiClient } from "@/api/axios";
import type { ApiResponse } from "@/types/api";
import type { NationalityData } from "@/types/nationality";

export async function GetNationality() {
  const { data } = await apiClient.post<ApiResponse<NationalityData>>(
    "/api/AgentBookingHistory/get_nationality",
    null,
  );

  if (!data.status) {
    throw new Error(data.message ?? "Get nationality request failed");
  }

  return data;
}